<template>
	<div  class="visit-view">
        <chillNavbar path_title="current_visit_and_craft" :current_visit="singleVisit.store_name_app" :craft="singleVisit.craft" :org="user_home_client" />
        <!-- <div class="visit-addres-box">
            <div class="address-box-section" >
                <span class="title-address">{{trans('craft')}}</span>
                <span class="title-address-value">{{trans(singleVisit.craft)}}</span>
            </div>
            <div class="address-box-section">
                <span class="title-address">{{trans('market_name')}}</span>
                <span class="title-address-value">{{trans(singleVisit.store_name_app)}}</span>
            </div>
            <div v-if="singleVisit.locked">
                <p>{{trans('this_visit_id_locked')}}</p>
                <p>{{trans('next_version_will_include_a_downloadable_report_here')}}</p>
                <p>{{trans('signed_at')}}: {{trans(singleVisit.locked_at)}}</p>
            </div>
        </div> -->
        <div ref="general" class="visit-general-data" v-if="singleVisit.locked == false && !singleVisit.general_data_done">
            <div v-if="!singleVisit.locked" class="button-box">
                <button class="button-box-element" @click="back_to_count()" >
                    <span> {{trans('edit_the_count_again')}} </span> 
                    <chill-icon class="dark new-tab-one-icon" size="medium-icon" icon="icon_edit_circle"/>
                </button>
                <chill-icon @click="deleteVisitModal = true" class="warning big-icon" icon="icon_delete" style="float: right; margin-top: 5px"/>
<!--                 <button class="button-box-element" style="float: right" @click="back_to_count()" >
                    <span> {{trans('edit_the_count_again')}} </span> 
                    <chill-icon class="dark new-tab-one-icon" size="medium-icon" icon="icon_edit_circle"/>
                </button> -->
            </div>
            <p>{{trans('visit_data_here')}}</p>
            <div v-for="(key,i) in checklistOrderToShow" :key="key+i" class="visit-form-element">
                <div v-if="statementCheck(checklistStrucuture[key])" :class="'form-field-'+checklistStrucuture[key].type+ ' ' +'form-field-row'">
                    <h3 class="title">{{trans(key)}}</h3>

                    <input v-if="checklistStrucuture[key].type === 'string'  && statementCheck(checklistStrucuture[key])" @change="visit_update(key)" v-model="visit_local_data[key]" type="text" name="" id="" class="input-field">
                    <input v-else-if="checklistStrucuture[key].type === 'int'  && statementCheck(checklistStrucuture[key])" @change="visit_update(key)" v-model="visit_local_data[key]" type="number" class="input-field">
                    <div v-else-if="checklistStrucuture[key].type === 'list'  && statementCheck(checklistStrucuture[key])" class="list-type-element">
                        <listType @change="visit_update(key)" asd="asd" :value="visit_local_data[key]" v-model="visit_local_data[key]"></listType>
                    </div>
                    <span v-else-if="checklistStrucuture[key].type === 'bool' && statementCheck(checklistStrucuture[key])" class="bool-element">
                        <label><input type="radio" @change="visit_update(key)" value="yes" v-model="visit_local_data[key]" id="one">{{trans('yes')}}</label>
                        <label><input type="radio" @change="visit_update(key)" value="no" v-model="visit_local_data[key]" id="two">{{trans('no')}}</label>
                    </span>
                    <v-select v-else-if="checklistStrucuture[key].type === 'option'  && statementCheck(checklistStrucuture[key])" :id="'select-'+key" v-model="visit_local_data[key]" :options="genereateOptions(checklistStrucuture[key].options)" :reduce="o => o.value" label="key" @input="visit_update(key)"/>
                    <Datepicker class="date" inputClass="date-input" v-else-if="checklistStrucuture[key].type === 'date' && statementCheck(checklistStrucuture[key])" v-model="visit_local_data[key]" placeholder="dd/mm/yyyy" format="dd.MM.yyyy" type="timestamp" @input="update_date(key)"></Datepicker>
                    <!-- <select v-else-if="checklistStrucuture[key].type === 'option'  && statementCheck(checklistStrucuture[key])" :id="'select-'+key" class="select-field" @change="visit_update(key)" v-model="visit_local_data[key]">
                        <option  v-for="option of genereateOptions(checklistStrucuture[key].options)" :value="option.value" :key="option.value" >{{option.key}}</option>
                    </select> -->
                </div>
            </div>
            <div class="button-box">
                <button class="button-box-element" @click="visit_local_data['general_data_done'] = true; visit_update('general_data_done')" >
                    <span> {{trans('edit_general_data_done')}} </span> 
                </button>
            </div>
        </div>
        <div v-else class="button-box">
            <button class="button-box-element" @click="visit_local_data['general_data_done'] = false; visit_update('general_data_done')">
                {{trans('press_here_to_modify_general_visit_data')}} 
            </button>
        </div>
<!--         <div v-else @click="visit_local_data['general_data_done'] = false; visit_update('general_data_done')" >
                {{trans('press_here_to_modify_general_visit_data')}}
        </div> -->
        <div v-if="!singleVisit.locked" class="visit-checklist-data">
            <h3>{{trans('create_a_checklist_for_components')}}</h3>
            <div
                v-for="(type, i) in numbers_more_than_zero(listOfTypes)"
                :key="i+type"
                class="checklist-row-data"
            >
                <div v-if="!checklist_blocked(type)" class="visit-row" :class="toogledType === type ? 'active' : ''" @click="toogleChecklistType(type)">
                    <span class="visit-text">{{trans(type)}}</span>
                    <span class="number-of-components">({{amount_of_done(type)}}/{{singleVisit.count[type]}})</span>
                    <span class="arrow-box">
                        <img class="hide-show-arrow" :class="toogledType === type ? 'hide' : ''" src="@/assets/down-arrow.png" alt="show-arrow" >
                        <img class="hide-show-arrow" :class="toogledType === type ? '' : 'hide'" src="@/assets/up-arrow.png" alt="show-arrow">
                    </span>
                </div>
                <div v-else class="visit-row-blocked" :class="toogledType === type ? 'active' : ''">
                    <span class="visit-text">{{trans(type)}}</span>
                    <span class="number-of-components">({{amount_of_done(type)}}/{{singleVisit.count[type]}})</span>
                </div>
                <div class="visit-checklist" :class="toogledType !== type ? 'hide' : ''">
                    <div class="visit-checklist-row-visit" v-for="check in showChecklist(type)" :key="check.checklist_id ? check.checklist_id : check.component_id">
                        <!-- <img class="checklist-row-delete delete" v-if="check.checklist_id" @click="delete_checklist_key = check.checklist_id; deleteModal = true" src="@/assets/delete.png" alt="delete"> -->
                        <div class="checklist-row-box" @click="toChecklist(check.checklist_id, check)">
                            <img v-if="check.front_image" class="checklist-row-image" :src="check.front_image" alt="" >
                            <img v-else class="checklist-row-no-image" src="@/assets/no-image-icon.png" alt="" >
                            <div class="checklist-row-text">
                                <span class="row-text">{{check.name}}</span>
                                <span v-if="check.checklist_id && !check.done && check.started" class="row-text">{{trans('started')}}</span>
                                <span v-else-if="check.checklist_id && check.done" class="row-text">{{trans('done_checklists')}}</span>
                                <span v-else class="row-text">{{trans('not_done')}}</span>
                            </div>
                        </div>
                        <div class="checklist-row-delete delete" v-if="check.checklist_id" @click="delete_checklist_key = check.checklist_id; deleteModal = true">
                            <chill-icon class="warning big-icon" icon="icon_delete"/>
                        </div>
                    </div>
                    <div v-if="toogledType === type" class="button-box">
                        <button class="button-box-element" @click="newChecklist({'type': type})">{{trans('add_another_checklist')}}</button>
                    </div>
                </div>
            </div>
            <div class="extra-comment title">
                <label>{{trans('visit_comment')}}
                    <textarea @change="visit_update('visit_general_data')" v-model="visit_local_data['visit_general_data']" type="text" name="" id="" class="textarea-bottom text-area"></textarea>
                </label>
            </div>
            <div class="button-box">
                <button class="button-box-element" v-if="!singleVisit.locked" @click="visitDone()">{{trans('sign_visit_as_done')}}</button>
            </div>
        </div>
        <modal
            v-if="deleteVisitModal" 
            component="warningModal"
            :componentprops="{header: trans('are_you_sure_you_want_to_delete_this_visit'), btnPrimary: trans('delete'), btnSecondary: trans('dont_delete')}"
            @disagree="deleteVisitModal = false"
            @agree="delete_visit()"
        />
        <modal
            v-if="deleteModal" 
            component="warningModal"
            :componentprops="{header: trans('are_you_sure_you_want_to_delete_this_checklist'), btnPrimary: trans('delete'), btnSecondary: trans('dont_delete')}"
            @disagree="deleteModal = false"
            @agree="delete_checklist()"
        />
        <modal
            v-if="showModal" 
            component="confirmModal"
            :componentprops="{possible_amount: possible_amount_count, done_amount: total_amount_count(), non_gray_amount: non_gray_amount_count()}"
            @disagree="showModal = false"
            @agree="confirmVisitDone"
        />
	</div>
</template>

<script>
	export default {
		name: 'visit',
		data() {
			return {
				newChecklistType: false,
                toogledType: '',
                visit_general_data: "",
                visit_local_data: {},
                showModal: false,
                data_loaded: false,
                deleteModal: false,
                deleteVisitModal: false,
                delete_checklist_key: "",
                grayout: {
                    "spring" : [
                        "heat_generator_oil_<100kW",
                        "heat_generator_oil_>100kW",
                        "fuel_storage",
                        "heat_generator_gas_<100kW",
                        "heat_generator_gas_>100kW",
                        "district_heating",
                        "circuits_distributors_heat",
                        "central_air_unit_<12000",
                        "central_air_unit_>12000_<30000",
                        "central_air_unit_>30000",
                        "central_air_unit_booster",
                        "fire_dampers",
                        "duct_smoke_detector",
                        "multifunc_room_air_supply",
                        "exhaust_air_toilets_staffrooms",
                        "exhaust_air_decentral",
                        "exhaust_hoods",
                        "exhaust_machine_room",
                        "air_handling_unit_heat_ac"
                    ],
                    "autumn" : [
                        "indoor_unit_cool_ac"
                    ]
                },
			}
		},
		computed: {
            checklistOrderToShow() {
                if(this.checklistStrucuture?.order) {
                    const filtredOrder = this.checklistStrucuture.order.filter(key => {
                        return this.statementCheck(this.checklistStrucuture[key]) ? key : null
                    })
                    
                    return filtredOrder
                }
                else {
                    return ''
                }
            },
			checklistsStartedCount(){
				let temp = {}
				for(let c of this.checklists){
					temp[c.type] = temp[c.type] ? temp[c.type] + 1 : 1;

				}
				return temp
			},
            possible_amount_count(){
                let re = 0
                for(let c of Object.values(this.singleVisit.count)){
                    re += c
                }
                return re
            },
		},
        watch: {
            singleVisit(){
                console.log('singleVisit: ', this.singleVisit)
                this.data_loaded = true
                this.startListOfTypes(this.singleVisit.craft)
                this.visit_local_data = this.singleVisit
            },
            '$route' (to) {
                if(to.name != "checklist" || to.name != "count"){
                    this.clearVisitData();
                }
            }
        },
		methods: {
            async delete_visit(){
                this.updateVisit(this.$route.params.visit_id, {deleted: true})
                console.log("delete this visit")
                this.$router.push({ path: `/market/${this.$route.params.market_id}`});
            },
            checklist_blocked(type) {
                if(this.grayout[this.visit_local_data['season']] == undefined) {
                    return false;
                }
                return this.grayout[this.visit_local_data['season']].includes(type) ? true :  false
            },
            non_gray_amount_count(){
                if(!this.grayout[this.visit_local_data['season']]){
                    return Object.values(this.visit_local_data.count).reduce((a, b) => a + b);
                }
                let temp = 0
                for(let key of Object.keys(this.visit_local_data.count)){
                    if(!this.grayout[this.visit_local_data['season']].includes(key)){
                        temp += this.visit_local_data.count[key]
                    }
                }
                return temp
            },
            delete_checklist(){
                this.deleteSingleChecklist(this.$route.params.visit_id, this.delete_checklist_key)
                this.deleteModal = false
                this.delete_checklist_key = ""
            },
            update_date(key){
                this.visit_local_data[key] = new Date(this.visit_local_data[key]).getTime();
                this.visit_update(key)
            },
            amount_of_done(type){
                let temp = 0
                for(let cl of this.checklists){
                    if(cl.type == type && cl.done){
                        temp ++;
                    }
                }
                return temp;
            },
            total_amount_count(){
                let re = 0
                for(let c of this.checklists){
                    if(c.done){
                        re += 1
                    }
                }
                return re
            },
            back_to_count(){
                this.$router.push({ path: `/count/${this.$route.params.market_id}/${this.$route.params.visit_id}/${this.singleVisit.craft}`});
            },
            genereateOptions(options){
                let re = []
                for(let o of options){
                    re.push({key: this.trans(o), value: o})
                }
                return re
            },
            statementCheck(struct){
                if(struct.statement){
                    if(struct.statement.type == "equal"){
                        if(this.singleVisit[struct.statement.key] == struct.statement.value){
                            return true
                        }
                    }else if(struct.statement.type == "greater_than"){
                        if(this.singleVisit[struct.statement.key] > struct.statement.value){
                            return true
                        }
                    }
                }else{
                    return true
                }
            },
            numbers_more_than_zero(lista){
                let temp = [];
                let pre_sort = [];
                for(let l of lista){
                    if(this.singleVisit.count[l] > 0 || this.subcomponents.some(x => l == x.type)){
                        pre_sort.push({trans: parseInt(this.trans(l).split(".")[1]), value: l})
                        //temp.push(l)
                    }
                }
                pre_sort.sort((a, b) => (a.order > b.order) ? 1 : -1)
                for(let ps of pre_sort){
                    temp.push(ps.value)
                }
                return temp.reverse()
            },
            showChecklist(type) {
                if(!type){
                    return []
                }
                let temp = this.checklists.filter(x => x.type === type  && x.type === this.toogledType ? x : null )
                if (type == this.toogledType){
                    return temp.concat(this.selectableComponents(type))
                }else{
                    return temp
                }
            },
            toogleChecklistType(type) {
                if(this.toogledType !== type)
                    this.toogledType = type
                else    
                    this.toogledType = ''
            },
            async visit_update(key){
                console.log("visit_update", key)
                let data = {}
                data[key] = this.visit_local_data[key]
                console.log(data)
                await this.updateVisit(this.$route.params.visit_id, data)
            },
			visitDone(){
                this.showModal = true;
            },
			async confirmVisitDone(signed_name){
                this.showModal = false;
                if(this.singleVisit.locked){
                    this.$router.push({ path: `/market/${this.$route.params.market_id}`});
                }else{
                    let faultyChecklists = await this.checkChecklistsForFaultyData(this.$route.params.visit_id);
                    if(faultyChecklists.length > 0){
                        //alert("fix: " + faultyChecklists.join(', '))
                        console.log("CAN NOT CREATE COMPONENTS OF: ", faultyChecklists)
                        //return false
                    }
                    await this.generateComponents(this.singleVisit, this.$route.params.visit_id, this.$route.params.market_id)

                    await this.updateVisit(this.$route.params.visit_id, {signed_name: signed_name, signed_by: this.getUser().uid, locked: true, locked_at: new Date().getTime()})
                    // this.$router.push({ path: `/market/${this.$route.params.market_id}`});
                    this.$router.push({ path: `/`});
                }
			},
			selectableComponents(type){
				let temp = []
				let allChecklistWithComponentId = []
				for(let c of this.checklists){
                    if(c.component_id){
                        allChecklistWithComponentId.push(c.component_id)
                    }
				}
                for(let c of this.components ? this.components : []){
					if(!allChecklistWithComponentId.includes(c.component_id) && c.type==type){
						temp.push(c)
					}
				}
				return temp
			},
			allComponentTypes(){
				if(!this.singleVisit.count){
					return []
				}
				let arr = []
				for(const [key, value] of Object.entries(this.singleVisit.count)){
					if(value > 0){
						arr.push(key)
					}
				}
				return arr
			},
			async toChecklist(checklist_id, data = false){
                if(checklist_id){
                    this.$router.push({ path: `/checklist/${this.$route.params.market_id}/${this.$route.params.visit_id}/${checklist_id}`});
                }else{
                    await this.newChecklist(data)
                }
			},
			async newChecklist(data = false){
				let id = await this.createChecklist(this.$route.params.visit_id, this.singleVisit?.store_name_app ? this.singleVisit?.store_name_app : "no_name", this.newChecklistType, data)
				this.$router.push({ path: `/checklist/${this.$route.params.market_id}/${this.$route.params.visit_id}/${id}` });
			}
		},
		mounted(){
            this.startComponentListener(this.$route.params.market_id)
			this.startSingleVisitListener(this.$route.params.visit_id)
			this.startChecklistListener(this.$route.params.visit_id)
			this.startComponentListener(this.$route.params.market_id)
            this.startChecklistStrucutre("visit")
            this.startSpecialCaseUserListener(this.getUser().uid)
		}
	}
</script>

<style lang="scss">
    .visit-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        max-width: 900px;
        .visit-general-data {
            border-radius: 4px;
            margin-bottom: 20px;
            .visit-form-element {
                width: 100%;
                margin: 8px 0px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                border-left: solid #1B608C 5px;
                width: 100%;
                padding: 0px 8px 12px 8px;
                box-sizing: border-box;
                .form-field-row {
                    width: 100%;
                    .input-field {
                        border: none;
                        border-bottom: solid #565760 1px;
                        &:focus {
                            outline: none;
                            border-bottom: solid #51D07D 1px;
                        }
                    }
                    .bool-element {
                        display: flex;
                        margin: 0px 12px;
                        > label {
                            display: flex;
                            flex-direction: column-reverse;
                            width: 33%;
                            &:nth-child(2) {
                                align-items: center;
                            }
                        }
                    }
                    .vdp-datepicker  {
                        width: 100% !important;
                        > div > .date-input {
                            border: none !important;
                            border-bottom: solid #565760 1px !important;
                        }
                    }
                    .select-field {
                        height: 28px;
                        border: solid #191A23 1px;
                        border-radius: 4px;
                        color: #1B608C;
                        height: 30px;
                        padding-left: 8px;
                        width: 100%;
                    }
                }
            }
        }
        .visit-checklist-data {
            border-radius: 4px;
            margin-bottom: 20px;
            .checklist-row-data {
                .visit-row {
                    margin: 8px 0px;
                    height: 56px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    border-left: solid #1B608C 5px;
                    background-color: #fff;
                    box-sizing: border-box;
                    // border-radius: 4px;
                    &:hover {
                        cursor: pointer;
                    }
                    .visit-text {
                        margin: auto;
                        /* flex: 2; */
                        margin-left: 8px;
                    }
                    .number-of-components {
                        margin-top: auto;
                        margin-bottom: auto;
                        margin-right: 12px;
                    }
                    .hide-show-arrow {
                        width: auto;
                        height: 14px;
                        margin: auto 8px;
                    }
                    .hide {
                        display: none;
                    }
                    .arrow-box {
                        margin-top: auto;
                        margin-bottom: auto;
                    }
                }
                .active {
                    border-left: solid #4FC4F0 5px !important;
                }
            }
            .visit-checklist {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .visit-checklist-row-visit {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    .checklist-row-delete {
                        display: flex;
                        justify-content: center;
                        width: 50px;
                        margin-left: 8px;
                        background-color: #fff;
                        > i {
                            margin-bottom: auto;
                        }
                    }
                    .checklist-row-box {
                        width: calc(100% - 30px);
                        height: 60px;
                        display: flex;
                        justify-content: space-between;
                        background-color: #fff;
                        &:hover {
                            cursor: pointer;
                        }
                        .checklist-row-image {
                            object-fit: cover;
                            width: 56px;
                            height: 56px;
                            margin: auto 2px
                        }
                        .checklist-row-no-image {
                            width: 60px;
                            height: 60px;
                        }
                        .checklist-row-text {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            .row-text {
                                margin: auto 8px;
                            }
                        }
                    }
                }
            }
            .hide {
                display: none;
            }
            .text-area {
                width: calc(100% - 12px);
                &:focus {
                    outline: none;
                    border-bottom: solid #51D07D 1px;
                }
            }
            .textarea-bottom {
                height: 100px;
                border: none;
                border-bottom: solid #565760 1px;
                &:focus {
                    outline: none;
                    border-bottom: solid #51D07D 1px;
                }
            }
            .extra-comment {
                width: 100%;
                margin: 8px 0px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                border-left: solid #1B608C 5px;
                padding: 0px 8px 12px 8px;
                box-sizing: border-box;
                > label {
                    width: 100%;
                }
            }
        }
    }
    .button-box {
        width: 100%;
        .button-box-element {
            width: 200px;
            background-color: #1B608C;
            color: #FFF;
            height: 28px;
            border-radius: 28px;
            border: none;
            margin-top: 8px;
            &:hover {
                cursor: pointer;
            }
        }
    }

    span {
        font-size: 14px;
    }

     .title {
        font-size: 14px;
        color: #191A23;
        font-weight: 300;
        margin: 4px;
    }
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }
    input[type=text], input[type=number], textarea {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
        font-weight: 300;
        height: 30px;
        padding-left: 8px;
        font-size: 14px;
        width: calc(100% - 14px);
    }
    input[type=radio] {
        position: relative;
        appearance: none;
        //margin-left: 0
    }
    input[type=radio]::before {
        content: '❏';
        font-family: 'FontAwesome';
        font-size: 120%;
        display: inline-block;
        letter-spacing: .75em
    }

    input[type=radio]:checked::before
    {
        content: '✓';
        color: #000000;
    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
    h3 {
        font-weight: normal;
        font-size: 16px;
    }
    p {
        font-size: 14px;
    }

    .remove {
        display: none;
    }
    .blocked {
        border-left: solid #ECEDF0 5px !important;
        color: #CBCCD5;
    }
    .visit-row-blocked {
        margin: 8px 0px;
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        // border-left: solid black 5px;
        background-color: #fff;
        box-sizing: border-box;
        border-left: solid #ECEDF0 5px !important;
        color: #CBCCD5;
        .visit-text {
            margin: auto;
            /* flex: 2; */
            margin-left: 8px;
        }
        .number-of-components {
            margin-top: auto;
            margin-bottom: auto;
            margin-right: 12px;
        }
        .hide-show-arrow {
            width: auto;
            height: 14px;
            margin: auto 8px;
        }
        .hide {
            display: none;
        }
        .arrow-box {
            margin-top: auto;
            margin-bottom: auto;
        }
    }    

</style>